import { ThemeContext } from 'styled-components';
import { useContext } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const Styles = () => {
  const theme = useContext(ThemeContext);
  return { col: { marginBottom: theme.spacing(8).rem() } };
};
